<template>
  <div>
    <div class="w3-modal" :class="{'show':modal === 1}">
      <div class="w3-modal-content">
        <div class="top-bar primary">
          <button class="w3-button" style="margin: 6px" @click="() => {modal = 0; term = ''; $emit('cancelar')}">
            <span class="w3-small">Cancelar</span>
          </button>
        </div>
        <div class="w3-padding w3-padding-16 w3-small">
          <div>
            <label :for="input"><b>Buscar Produtos</b></label>
            <div style="position: relative;">
              <i class="fa fa-times w3-padding" @click="limparSearch(input)" style="position: absolute; right: 6px; top: 3px; cursor: pointer" v-show="term.trim() !== ''"></i>
              <input type="text" class="w3-input w3-border" :id="input" v-model="term"
                     @keyup="pesquisar(false)"
                     @keyup.enter="searchResults.length === 1 ? selecionarProduto(searchResults[0]) : ''"
                     placeholder="Nome, referênia, tabela, categoria.."
                     autocomplete="new-street-address">
            </div>
          </div>

          <div class="w3-margin-top">
            <div class="w3-border box-container" v-show="term.trim() !== ''">
              <a href="javascript:" class="w3-padding w3-padding-16 w3-block w3-border-bottom" v-for="r in searchResults" @click="selecionarProduto(r)">
                <div class="w3-cell-row">
                  <div class="w3-cell">
                    <b>{{r.ref_tabela}}</b> - {{r.nome_produto}}
                    <span v-show="r.nome_tabela"><b>{{r.nome_tabela}}</b></span>
                  </div>
                  <div class="w3-cell w3-right-align" style="width: 70px"><b>R$ {{r.valor}}</b></div>
                </div>
              </a>

              <div class="w3-display-middle w3-center" v-show="searchResults.length === 0">
                <i class="fa fa-frown-o fa-2x w3-padding"></i> <br>
                Não encontrado resultados!
              </div>

            </div>

            <div class="w3-border box-container" v-show="term.trim() === ''">
              <a href="javascript:" class="w3-padding w3-padding-16 w3-block w3-border-bottom" v-for="r in produtos" @click="selecionarProduto(r)">
                <div class="w3-cell-row">
                  <div class="w3-cell">
                    {{r.nome_produto}}
                    <span v-show="r.nome_tabela"><b>{{r.nome_tabela}}</b></span>
                  </div>
                  <div class="w3-cell w3-right-align" style="width: 70px"><b>R$ {{r.valor}}</b></div>
                </div>
              </a>
            </div>

          </div>
        </div>
      </div>
    </div>


      <div class="w3-modal" :class="{'show': modal === 2}">
          <div class="w3-modal-content w3-small">
              <div class="top-bar primary header-fixed">
                  <button class="w3-button" style="margin: 6px" @click="modal = 0">
                      Cancelar
                  </button>
                  <button class="w3-button w3-right" style="margin: 6px" @click="retornarDados">
                      Concluir
                      <i class="fa fa-edit"></i>
                  </button>
              </div>
              <div class="w3-row w3-margin-top container-header-fixed">
                  <div style="padding: 20px 16px 42px">

                      <div v-show="dados.produto.id_medida === '2'">
                          <label><b>Quantidade</b></label>
                          <money v-bind="kilo" class="w3-input w3-border" v-model="dados.quantidade"/>
                      </div>

                      <div class="w3-margin-bottom" v-show="dados.produto.id_medida === '1'">
                          <label><b>Quantidade</b></label>
                          <div class="w3-cell-row w3-border">
                              <div class="w3-cel">
                                  <div style="font-weight: bold; padding: 6px">{{dados.quantidade | fixed}}</div>
                              </div>
                              <div class="w3-cell" style="width:25%">
                                  <button class="w3-button primary w3-block" @click="minusQtd()">
                                      <i class="fa fa-minus"></i>
                                  </button>
                              </div>
                              <div class="w3-cell" style="width:25%">
                                  <button class="w3-button primary w3-block w3-border-left w3-border-white" @click="plusQtd()">
                                      <i class="fa fa-plus"></i>
                                  </button>
                              </div>
                          </div>
                      </div>
                      <label><b>Dados</b></label>
                      <div class="w3-border w3-margin-bottom">
                          <div class="w3-cell-row w3-padding w3-border-bottom">
                              <div class="w3-cell" style="width: 70px">
                                  <b>Item:</b>
                              </div>
                              <div class="w3-cell">
                                  {{dados.produto.nome_produto}}
                                  <b v-show="dados.produto.principal !== '1'"> - {{dados.produto.nome_tabela}}</b>
                              </div>
                          </div>
                          <div class="w3-cell-row w3-padding w3-border-bottom">
                              <div class="w3-cell" style="width: 70px">
                                  <b>QTD:</b>
                              </div>
                              <div class="w3-cell">
                                  {{dados.quantidade | fixed}}
                              </div>
                          </div>
                          <div class="w3-cell-row w3-padding">
                              <div class="w3-cell" style="width: 70px">
                                  <b>Total:</b>
                              </div>
                              <div class="w3-cell">
                                  R$ {{(dados.quantidade * dados.produto.valor) | valor}}
                              </div>
                          </div>
                      </div>
                      <label><b>Observações</b></label>
                      <textarea class="w3-input w3-border" placeholder="Informaçoes adicionais" v-model="dados.observacao"></textarea>
                  </div>
              </div>
          </div>
      </div>

  </div>
</template>

<script>
    import {Money} from 'v-money'
    export default {
      name: "inserir",
      components: {Money},
      data() {
        return {
          modal: 0,
          tipoBusca: 1,
          token: localStorage.getItem('key'),
          term: '',
          produtos: [],
          produtosDivisao: [],

          input: ID(),
          input2: ID(),
          input3: ID(),

          dados: {
            produto: {},
            divisoes: [],
            quantidade: 1,
            desconto: 0
          },

          searchResults: [],

          valorProduto: 0,
          money: {
            decimal: '.',
            thousands: '',
            prefix: 'R$ ',
            suffix: '',
            precision: 2,
            masked: false
          },
            kilo: {
                decimal: '.',
                thousands: '',
                prefix: 'KG ',
                suffix: '',
                precision: 3,
                masked: false
            }
        }
      },

      methods: {
        buscarProdutos() {
          this.$http.get(base_url + 'produtos-venda/' + this.token)
            .then(response => {
              this.produtos = response.data;
              this.searchResults = this.produtos;

            }, res => {
              closeLoading();
              if (res.status === 404) {
                this.$router.push('/login');
              }
            });
        },

        pesquisar(callback) {
          let keys = [
            "nome_produto",
            "nome_categoria",
            "nome_tabela",
            "ref_tabela"
          ];

          let options = {
            shouldSort: true,
            threshold: 0.2,
            location: 0,
            distance: 100,
            maxPatternLength: 32,
            minMatchCharLength: 1,
            keys: keys
          };

          this.$search(this.term, this.produtos, options).then(results => {
            this.searchResults = results;

            if (callback) {
              callback();
            }
          })
        },

        limparSearch(id) {
          //this.focusElement(id);
          this.term = '';
        },

        selecionarProduto(produto) {
          this.dados.quantidade = 1;
          this.dados.produto = produto;
          this.modal = 2;
        },

        retornarDados() {
          this.$emit('atualizarPedidos', this.dados);
          this.modal = 0;
        },

        pesquisarProduto(termo, qtd) {
          this.dados = {
            produto: {},
            divisoes: [],
            adicionais: [],
            remocoes: [],
            quantidade: 1,
            desconto: 0
          };

          if (qtd) {
            if (qtd <= 0) {
              openModalMsg("Atenção!", "Insisra uma quantidade válida.");
              return;
            }

            this.dados.quantidade = qtd;
          }

          if (termo) {
            this.tipoBusca = 2;
            this.term = termo;
            this.pesquisar(() => {
              if (this.searchResults.length === 1) {
                this.selecionarProduto(this.searchResults[0])

              } else {
                this.modal = 1;
              }
            });

          } else {
            this.modal = 1;
            this.limparSearch(this.input);
          }
        },

        plusQtd() {
          this.dados.quantidade++;
        },

        minusQtd() {
          if (this.dados.quantidade > 1 && this.desconto > ((this.dados.quantidade - 1) * this.dados.produto.valor)) {
            openModalMsg("Atenção","Para diminuir a quantidade, remova o desconto.");
            return;
          }

          if (this.dados.quantidade > 1) {
            this.dados.quantidade--;
          }
        },
      },

      created() {
        this.$parent.$on('pesquisarProduto', this.pesquisarProduto);
      },

      mounted() {
        this.buscarProdutos();
        //this.modal = 3;
      },

      filters: {
        valor(value) {
          if (value !== null || value !== undefined) {
            return parseFloat(value).toFixed(2);
          }
        },

        fixed(value) {
          if (value !== null || value !== undefined) {
            return parseFloat(value).toFixed();
          }
        }
      }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/pdv/PesquisarProduto.vue